import React from 'react';

interface componentProps {
    iconname : string,
    className? : string,
    size? : number,
    color?:string;
    bold?: boolean,
    opacity?: string,
    customstyle?: React.CSSProperties,
    onClick?:(e:React.MouseEvent<HTMLElement>) => void,
    style?: CSSStyleRule
}
const JetFontIcon = (props : componentProps, ref : React.Ref<any>) => {
    const fontIconClassPrefix = 'pie2-font-icons-'
    const iconClass = `${fontIconClassPrefix}${props.iconname}`;
    const iconColor = props.color;
    const iconSize = props.size || 12;
    const fontWeight =  props.bold ? 'bold' : 'normal';
    const { 
        className,
        ...otherProps
      } = props;   
    const classNames = ['jetFontIcon',iconClass, className].join(' ');

    return <i ref={ref} {...otherProps} className={classNames} style={{fontSize: `${iconSize}px`, fontWeight: fontWeight, color: iconColor,...props.customstyle}}></i>
}

export enum JET_FONTICON_ALIASES  {
    ALCOHOL_FILLED_SMALL = 'alcohol-filled-small', 
    ALCOHOL_FILLED = 'alcohol-filled', 
    ALCOHOL_SMALL = 'alcohol-small', 
    ALCOHOL = 'alcohol', 
    ALERT_CIRCLE_FILLED = 'alert-circle-filled', 
    ALERT_CIRCLE = 'alert-circle', 
    ALERT_TRIANGLE_FILLED = 'alert-triangle-filled', 
    ALERT_TRIANGLE = 'alert-triangle', 
    ANDROID_CIRCLE_FILLED = 'android-circle-filled', 
    ANDROID_CIRCLE = 'android-circle', 
    APP_ORDER_SMALL = 'app-order-small', 
    APP_ORDER = 'app-order', 
    APP_RESTAURANT = 'app-restaurant', 
    APP_SUCCESS = 'app-success', 
    APP_USERS_SMALL = 'app-users-small', 
    APP_USERS = 'app-users', 
    APPLE_CIRCLE_FILLED = 'apple-circle-filled', 
    APPLE_CIRCLE = 'apple-circle', 
    APPLE = 'apple', 
    ARROW_DOWN_CIRCLE_FILLED = 'arrow-down-circle-filled', 
    ARROW_DOWN_CIRCLE = 'arrow-down-circle', 
    ARROW_DOWN = 'arrow-down', 
    ARROW_IN_CIRCLE = 'arrow-in-circle', 
    ARROW_LEFT = 'arrow-left', 
    ARROW_OUT_CIRCLE = 'arrow-out-circle', 
    ARROW_RIGHT = 'arrow-right', 
    ARROW_UP_LEFT = 'arrow-up-left', 
    ARROW_UP = 'arrow-up', 
    BACKPACK_SMALL = 'backpack-small', 
    BACKPACK = 'backpack', 
    BAG_FILLED = 'bag-filled', 
    BAG_SMALL_FILLED = 'bag-small-filled', 
    BAG_SMALL = 'bag-small', 
    BAG = 'bag', 
    BALLOT_BOX_SMALL = 'ballot-box-small', 
    BALLOT_BOX = 'ballot-box', 
    BARCODE_SMALL = 'barcode-small', 
    BARCODE = 'barcode', 
    BASKET_SMALL = 'basket-small', 
    BASKET = 'basket', 
    BIKE_FILLED_SMALL = 'bike-filled-small', 
    BIKE_FILLED = 'bike-filled', 
    BIKE_SMALL = 'bike-small', 
    BIKE = 'bike', 
    BLOGGER_CIRCLE_FILLED = 'blogger-circle-filled', 
    BLOGGER_CIRCLE = 'blogger-circle', 
    BRAND_HIGHLIGHT = 'brand-highlight', 
    BULB_LIGHTNING_SMALL = 'bulb-lightning-small', 
    BULB_LIGHTNING = 'bulb-lightning', 
    CALENDAR_ADD_SMALL = 'calendar-add-small', 
    CALENDAR_ADD = 'calendar-add', 
    CALENDAR_ALERT_SMALL = 'calendar-alert-small', 
    CALENDAR_ALERT = 'calendar-alert', 
    CALENDAR_DAY_SMALL = 'calendar-day-small', 
    CALENDAR_DAY = 'calendar-day', 
    CALENDAR_EDIT_SMALL = 'calendar-edit-small', 
    CALENDAR_EDIT = 'calendar-edit', 
    CALENDAR_ERROR_SMALL = 'calendar-error-small', 
    CALENDAR_ERROR = 'calendar-error', 
    CALENDAR_FILLED_SMALL = 'calendar-filled-small', 
    CALENDAR_FILLED = 'calendar-filled', 
    CALENDAR_REPEAT = 'calendar-repeat', 
    CALENDAR_SMALL = 'calendar-small', 
    CALENDAR_STAR_SMALL = 'calendar-star-small', 
    CALENDAR_STAR = 'calendar-star', 
    CALENDAR = 'calendar', 
    CAMERA = 'camera', 
    CAR_CLOCK_SMALL = 'car-clock-small', 
    CAR_CLOCK = 'car-clock', 
    CAR = 'car', 
    CARET_DOWN_FILLED = 'caret-down-filled', 
    CARET_DOWN = 'caret-down', 
    CARET_LEFT_FILLED = 'caret-left-filled', 
    CARET_LEFT = 'caret-left', 
    CARET_RIGHT_FILLED = 'caret-right-filled', 
    CARET_RIGHT = 'caret-right', 
    CARET_UP_FILLED = 'caret-up-filled', 
    CARET_UP = 'caret-up', 
    CASH_CARD_FILLED_SMALL = 'cash-card-filled-small', 
    CASH_CARD_FILLED = 'cash-card-filled', 
    CASH_CARD_SMALL = 'cash-card-small', 
    CASH_CARD = 'cash-card', 
    CASH_FILLED_SMALL = 'cash-filled-small', 
    CASH_FILLED = 'cash-filled', 
    CASH_SMALL = 'cash-small', 
    CASH = 'cash', 
    CHART_HEART = 'chart-heart', 
    CHART_INCREASE_SMALL = 'chart-increase-small', 
    CHART_INCREASE = 'chart-increase', 
    CHART_MARKER = 'chart-marker', 
    CHAT_BOT_SMALL = 'chat-bot-small', 
    CHAT_BOT = 'chat-bot', 
    CHAT_CONVERSATION_SMALL = 'chat-conversation-small', 
    CHAT_CONVERSATION = 'chat-conversation', 
    CHAT_FILLED_SMALL = 'chat-filled-small', 
    CHAT_FILLED = 'chat-filled', 
    CHAT_HEART_SMALL = 'chat-heart-small', 
    CHAT_HELP = 'chat-help', 
    CHAT_SMALL = 'chat-small', 
    CHAT = 'chat', 
    CHECK_CIRCLE_FILLED = 'check-circle-filled', 
    CHECK_CIRCLE = 'check-circle', 
    CHECK = 'check', 
    CHECKBOX_SELECTED = 'checkbox-selected', 
    CHECKBOX = 'checkbox', 
    CHEQUE_FILLED_SMALL = 'cheque-filled-small', 
    CHEQUE_FILLED = 'cheque-filled', 
    CHEQUE_SMALL = 'cheque-small', 
    CHEQUE = 'cheque', 
    CHEVRON_DOUBLE_LEFT = 'chevron-double-left', 
    CHEVRON_DOUBLE_RIGHT = 'chevron-double-right', 
    CHEVRON_DOWN = 'chevron-down', 
    CHEVRON_LEFT = 'chevron-left', 
    CHEVRON_RIGHT = 'chevron-right', 
    CHEVRON_SPLIT = 'chevron-split', 
    CHEVRON_UP = 'chevron-up', 
    CLOCK_ADD = 'clock-add', 
    CLOCK_ALERT = 'clock-alert', 
    CLOCK_FILLED = 'clock-filled', 
    CLOCK_REFRESH = 'clock-refresh', 
    CLOCK = 'clock', 
    CLOSE_CIRCLE_FILLED = 'close-circle-filled', 
    CLOSE_CIRCLE = 'close-circle', 
    CLOSE = 'close', 
    CLOUD_DOWNLOAD_SMALL = 'cloud-download-small', 
    CLOUD_DOWNLOAD = 'cloud-download', 
    CLOUD_ERROR = 'cloud-error', 
    CLOUD_SUCCESS_SMALL = 'cloud-success-small', 
    CLOUD_SUCCESS = 'cloud-success', 
    CLOUD_UPLOAD_SMALL = 'cloud-upload-small', 
    CLOUD_UPLOAD = 'cloud-upload', 
    CLOUD = 'cloud', 
    COMPONENTS = 'components', 
    CONSENT = 'consent', 
    CONVENIENCE = 'convenience', 
    CONVERSION_RATE_SMALL = 'conversion-rate-small', 
    CONVERSION_RATE = 'conversion-rate', 
    COOKIE_POLICY = 'cookie-policy', 
    COPY_FILLED_SMALL = 'copy-filled-small', 
    COPY_FILLED = 'copy-filled', 
    COPY_SMALL = 'copy-small', 
    COPY = 'copy', 
    CREDIT_CARD_FILLED_SMALL = 'credit-card-filled-small', 
    CREDIT_CARD_FILLED = 'credit-card-filled', 
    CREDIT_CARD_HOME_FILLED_SMALL = 'credit-card-home-filled-small', 
    CREDIT_CARD_HOME_FILLED = 'credit-card-home-filled', 
    CREDIT_CARD_HOME_SMALL = 'credit-card-home-small', 
    CREDIT_CARD_HOME = 'credit-card-home', 
    CREDIT_CARD_SMALL = 'credit-card-small', 
    CREDIT_CARD = 'credit-card', 
    CURRY_SMALL = 'curry-small', 
    CURRY = 'curry', 
    CUTLERY_FILLED_SMALL = 'cutlery-filled-small', 
    CUTLERY_FILLED = 'cutlery-filled', 
    CUTLERY_SMALL = 'cutlery-small', 
    CUTLERY = 'cutlery', 
    DASHBOARD_SMALL = 'dashboard-small', 
    DASHBOARD = 'dashboard', 
    DELIVERY_FEE_SMALL = 'delivery-fee-small', 
    DELIVERY_FEE = 'delivery-fee', 
    DINE_IN = 'dine-in', 
    DIRECTIONS_SMALL = 'directions-small', 
    DIRECTIONS = 'directions', 
    DISH = 'dish', 
    DOCUMENT_SMALL = 'document-small', 
    DOCUMENT = 'document', 
    DOLLAR_SMALL = 'dollar-small', 
    DOLLAR = 'dollar', 
    DOWNLOAD = 'download', 
    DRAG = 'drag', 
    DRINK_SMALL = 'drink-small', 
    DRINK = 'drink', 
    DRIVER_CAR_SMALL = 'driver-car-small', 
    DRIVER_CAR = 'driver-car', 
    DRIVER_MOPED_SMALL = 'driver-moped-small', 
    DRIVER_MOPED = 'driver-moped', 
    EDIT_FILLED_SMALL = 'edit-filled-small', 
    EDIT_FILLED = 'edit-filled', 
    EDIT_SMALL = 'edit-small', 
    EDIT = 'edit', 
    EMAIL_FILLED = 'email-filled', 
    EMAIL = 'email', 
    EMPLOYEE_SEARCH_SMALL = 'employee-search-small', 
    EMPLOYEE_SEARCH = 'employee-search', 
    ENGINEERS = 'engineers', 
    EURO_SMALL = 'euro-small', 
    EURO = 'euro', 
    EXTERNAL_LINK = 'external-link', 
    EYE_FILLED = 'eye-filled', 
    EYE_OFF_FILLED = 'eye-off-filled', 
    EYE_OFF = 'eye-off', 
    EYE = 'eye', 
    FACE_HAPPY = 'face-happy', 
    FACEBOOK_CIRCLE_FILLED = 'facebook-circle-filled', 
    FACEBOOK_CIRCLE = 'facebook-circle', 
    FILTERS_FILLED = 'filters-filled', 
    FILTERS_SMALL = 'filters-small', 
    FILTERS = 'filters', 
    FIRE = 'fire', 
    FLOWERS_SMALL = 'flowers-small', 
    FLOWERS = 'flowers', 
    FOOD_FILLED_SMALL = 'food-filled-small', 
    FOOD_FILLED = 'food-filled', 
    FOOD_READY_SMALL = 'food-ready-small', 
    FOOD_READY = 'food-ready', 
    FOOD_SMALL = 'food-small', 
    FOOD = 'food', 
    FOUNDATIONS = 'foundations', 
    FRIED_CHICKEN_SMALL = 'fried-chicken-small', 
    FRIED_CHICKEN = 'fried-chicken', 
    FRIES_SMALL = 'fries-small', 
    FRIES = 'fries', 
    FULL_SCREEN_EXPAND = 'full-screen-expand', 
    FULLSCREEN_EXIT = 'fullscreen-exit', 
    GEOLOCATION_CIRCLE_FILLED = 'geolocation-circle-filled', 
    GEOLOCATION_CIRCLE = 'geolocation-circle', 
    GEOLOCATION_FILLED = 'geolocation-filled', 
    GEOLOCATION = 'geolocation', 
    GIFT_CARD_SMALL = 'gift-card-small', 
    GIFT_CARD = 'gift-card', 
    GIFT_FILLED = 'gift-filled', 
    GIFT = 'gift', 
    GOOGLE_CIRCLE_FILLED = 'google-circle-filled', 
    GOOGLE_CIRCLE = 'google-circle', 
    GRID_VIEW_FILLED = 'grid-view-filled', 
    GRID_VIEW = 'grid-view', 
    GROCERY_SMALL = 'grocery-small', 
    GROCERY = 'grocery', 
    HAND_COINS_SMALL = 'hand-coins-small', 
    HAND_COINS = 'hand-coins', 
    HAND_HEART_SMALL = 'hand-heart-small', 
    HAND_HEART = 'hand-heart', 
    HEADSET_SMALL = 'headset-small', 
    HEADSET = 'headset', 
    HEART_FILLED = 'heart-filled', 
    HEART = 'heart', 
    HELMET_SMALL = 'helmet-small', 
    HELMET = 'helmet', 
    HELP_CIRCLE_FILLED = 'help-circle-filled', 
    HELP_CIRCLE = 'help-circle', 
    HI_VIS_SMALL = 'hi-vis-small', 
    HI_VIS = 'hi-vis', 
    HIGH_CONTRAST = 'high-contrast', 
    HOUSE_FILLED_SMALL = 'house-filled-small', 
    HOUSE_FILLED = 'house-filled', 
    HOUSE_SMALL = 'house-small', 
    HOUSE = 'house', 
    ICE_CREAM_SMALL = 'ice-cream-small', 
    ICE_CREAM = 'ice-cream', 
    ID_CARD_SMALL = 'id-card-small', 
    ID_CARD = 'id-card', 
    IMAGE_ADD_SMALL = 'image-add-small', 
    IMAGE_ADD = 'image-add', 
    IMAGE_FILLED = 'image-filled', 
    IMAGE_SMALL_FILLED = 'image-small-filled', 
    IMAGE_SMALL = 'image-small', 
    IMAGE = 'image', 
    INFO_CIRCLE_FILLED = 'info-circle-filled', 
    INFO_CIRCLE = 'info-circle', 
    INFO_MARKER = 'info-marker', 
    INSTAGRAM_CIRCLE_FILLED = 'instagram-circle-filled', 
    INSTAGRAM_CIRCLE = 'instagram-circle', 
    KEBAB_BOWL_SMALL = 'kebab-bowl-small', 
    KEBAB_BOWL = 'kebab-bowl', 
    KEBAB_SMALL = 'kebab-small', 
    KEBAB = 'kebab', 
    KEY_UNLOCK_SMALL = 'key-unlock-small', 
    KEY_UNLOCK = 'key-unlock', 
    KEY = 'key', 
    KITCHEN = 'kitchen', 
    KOSHER = 'kosher', 
    LANGUAGE = 'language', 
    LAW = 'law', 
    LAYERS = 'layers', 
    LEI_SMALL = 'lei-small', 
    LEI = 'lei', 
    LEV_SMALL = 'lev-small', 
    LEV = 'lev', 
    LIGHTNING = 'lightning', 
    LINK = 'link', 
    LINKEDIN_CIRCLE_FILLED = 'linkedin-circle-filled', 
    LINKEDIN_CIRCLE = 'linkedin-circle', 
    LIST_SMALL = 'list-small', 
    LIST = 'list', 
    LOADING = 'loading', 
    LOCATION_PIN_FILLED = 'location-pin-filled', 
    LOCATION_PIN_FOOD_FILLED = 'location-pin-food-filled', 
    LOCATION_PIN_FOOD = 'location-pin-food', 
    LOCATION_PIN_RESTAURANT_SMALL = 'location-pin-restaurant-small', 
    LOCATION_PIN_RESTAURANT = 'location-pin-restaurant', 
    LOCATION_PIN_USER = 'location-pin-user', 
    LOCATION_PIN = 'location-pin', 
    LOCATION_RESTAURANT_SMALL = 'location-restaurant-small', 
    LOCATION_RESTAURANT = 'location-restaurant', 
    LOCATION_TARGET_SMALL = 'location-target-small', 
    LOCATION_TARGET = 'location-target', 
    LOCK = 'lock', 
    LOGO_POINTS = 'logo-points', 
    LOGOUT = 'logout', 
    MANAGEMENT = 'management', 
    MEAL_VOUCHER_FILLED = 'meal-voucher-filled', 
    MEAL_VOUCHER_SMALL_FILLED = 'meal-voucher-small-filled', 
    MEAL_VOUCHER_SMALL = 'meal-voucher-small', 
    MEAL_VOUCHER = 'meal-voucher', 
    MEGAPHONE = 'megaphone', 
    MENU = 'menu', 
    MICROPHONE_SMALL = 'microphone-small', 
    MICROPHONE = 'microphone', 
    MICROSOFT_CIRCLE_FILLED = 'microsoft-circle-filled', 
    MICROSOFT_CIRCLE = 'microsoft-circle', 
    MINUS_CIRCLE_FILLED = 'minus-circle-filled', 
    MINUS_CIRCLE = 'minus-circle', 
    MINUS = 'minus', 
    MOON = 'moon', 
    MOPED_SMALL = 'moped-small', 
    MOPED = 'moped', 
    MORE_HORIZONTAL = 'more-horizontal', 
    MORE_VERTICAL = 'more-vertical', 
    NACHOS_SMALL = 'nachos-small', 
    NACHOS = 'nachos', 
    NAVIGATION_COLLAPSE_SMALL = 'navigation-collapse-small', 
    NAVIGATION_EXPAND_SMALL = 'navigation-expand-small', 
    NAVIGATION_EXPAND = 'navigation-expand', 
    NAVIGATION_SMALL = 'navigation-small', 
    NETWORK_ERROR_SMALL = 'network-error-small', 
    NETWORK_ERROR = 'network-error', 
    NOODLES_SMALL = 'noodles-small', 
    NOODLES = 'noodles', 
    NOTE = 'note', 
    NOTIFICATION_FILLED = 'notification-filled', 
    NOTIFICATION_OFF = 'notification-off', 
    NOTIFICATION = 'notification', 
    NUMBER_SYMBOL = 'number-symbol', 
    NUMERO_SYMBOL = 'numero-symbol', 
    NUTS = 'nuts', 
    OFFER_SMALL = 'offer-small', 
    OFFER_STAR_FILLED = 'offer-star-filled', 
    OFFER_STAR_SMALL_FILLED = 'offer-star-small-filled', 
    OFFER_STAR_SMALL = 'offer-star-small', 
    OFFER_STAR = 'offer-star', 
    OFFER = 'offer', 
    OFFICE_SMALL = 'office-small', 
    OFFICE = 'office', 
    ORDER_FILLED_SMALL = 'order-filled-small', 
    ORDER_FILLED = 'order-filled', 
    ORDER_SMALL = 'order-small', 
    ORDER = 'order', 
    OVER_16_SMALL = 'over-16-small', 
    OVER_16 = 'over-16', 
    OVER_18_SMALL = 'over-18-small', 
    OVER_18 = 'over-18', 
    OVER_21_SMALL = 'over-21-small', 
    OVER_21 = 'over-21', 
    PAINTBRUSH = 'paintbrush', 
    PATTERNS = 'patterns', 
    PAUSE_CIRCLE_FILLED = 'pause-circle-filled', 
    PAUSE_CIRCLE = 'pause-circle', 
    PAUSE = 'pause', 
    PERCENTAGE = 'percentage', 
    PET_SUPPLIES = 'pet-supplies', 
    PHARMACY = 'pharmacy', 
    PICK_UP = 'pick-up', 
    PIE_CHART = 'pie-chart', 
    PIE = 'pie', 
    PIN_HOME_FILLED_SMALL = 'pin-home-filled-small', 
    PIN_HOME_FILLED = 'pin-home-filled', 
    PIN_HOME_SMALL = 'pin-home-small', 
    PIN_HOME = 'pin-home', 
    PINTEREST_CIRCLE_FILLED = 'pinterest-circle-filled', 
    PINTEREST_CIRCLE = 'pinterest-circle', 
    PIZZA_SMALL = 'pizza-small', 
    PIZZA = 'pizza', 
    PLANE = 'plane', 
    PLAY_CIRCLE_FILLED = 'play-circle-filled', 
    PLAY_CIRCLE = 'play-circle', 
    PLAY = 'play', 
    PLUS_CIRCLE_FILLED = 'plus-circle-filled', 
    PLUS_CIRCLE = 'plus-circle', 
    PLUS = 'plus', 
    POUND_SMALL = 'pound-small', 
    POUND = 'pound', 
    PREPARE_PAUSE = 'prepare-pause', 
    PREPARE = 'prepare', 
    PRESENTATION_CHART_SMALL = 'presentation-chart-small', 
    PRESENTATION_CHART = 'presentation-chart', 
    RADIO_SELECTED = 'radio-selected', 
    RADIO = 'radio', 
    RECEIPT_ERROR_SMALL = 'receipt-error-small', 
    RECEIPT_ERROR = 'receipt-error', 
    RECEIPT_SMALL = 'receipt-small', 
    RECEIPT_SUCCESS_SMALL = 'receipt-success-small', 
    RECEIPT_SUCCESS = 'receipt-success', 
    RECEIPT = 'receipt', 
    RECYCLE = 'recycle', 
    REFRESH = 'refresh', 
    RESIZE = 'resize', 
    RESTAURANT_FILLED_SMALL = 'restaurant-filled-small', 
    RESTAURANT_FILLED = 'restaurant-filled', 
    RESTAURANT_MENU_SMALL = 'restaurant-menu-small', 
    RESTAURANT_MENU = 'restaurant-menu', 
    RESTAURANT_SMALL = 'restaurant-small', 
    RESTAURANT = 'restaurant', 
    RESTRICTED = 'restricted', 
    REVIEW_SMALL = 'review-small', 
    REVIEW = 'review', 
    RIBBON_HEART_SMALL = 'ribbon-heart-small', 
    RIBBON_HEART = 'ribbon-heart', 
    RIBBON_STAR_SMALL = 'ribbon-star-small', 
    RIBBON_STAR = 'ribbon-star', 
    RIBBON_SUCCESS_SMALL = 'ribbon-success-small', 
    RIBBON_SUCCESS = 'ribbon-success', 
    ROCKET_SHIP = 'rocket-ship', 
    ROUTE_PIN = 'route-pin', 
    RSS_SMALL = 'rss-small', 
    RSS = 'rss', 
    SALAD_SMALL = 'salad-small', 
    SALAD = 'salad', 
    SANDWICH_SMALL = 'sandwich-small', 
    SANDWICH = 'sandwich', 
    SEARCH = 'search', 
    SEND = 'send', 
    SERVICE_CHANGE_SMALL = 'service-change-small', 
    SERVICE_CHANGE = 'service-change', 
    SETTINGS_FILLED_SMALL = 'settings-filled-small', 
    SETTINGS_SMALL = 'settings-small', 
    SHARE = 'share', 
    SHEKEL_SMALL = 'shekel-small', 
    SHEKEL = 'shekel', 
    SIGN_CLOSED = 'sign-closed', 
    SNOWFLAKE = 'snowflake', 
    SORT_ASCENDING_SMALL = 'sort-ascending-small', 
    SORT_ASCENDING = 'sort-ascending', 
    SORT_DESCENDING_SMALL = 'sort-descending-small', 
    SORT_DESCENDING = 'sort-descending', 
    SORT_SMALL = 'sort-small', 
    SORT = 'sort', 
    SOUND_OFF = 'sound-off', 
    SOUND_ON_FILLED_SMALL = 'sound-on-filled-small', 
    SOUND_ON_FILLED = 'sound-on-filled', 
    SOUND_ON_SMALL = 'sound-on-small', 
    SOUND_ON = 'sound-on', 
    SPICY = 'spicy', 
    SPONSORED = 'sponsored', 
    STAMPCARD_10_FILLED = 'stampcard-10-filled', 
    STAMPCARD_10 = 'stampcard-10', 
    STAMPCARD_FILLED_SMALL = 'stampcard-filled-small', 
    STAMPCARD_FILLED = 'stampcard-filled', 
    STAMPCARD_SMALL = 'stampcard-small', 
    STAMPCARD = 'stampcard', 
    STAR_CIRCLE_FILLED = 'star-circle-filled', 
    STAR_CIRCLE = 'star-circle', 
    STAR_FILLED = 'star-filled', 
    STAR_HALF_FILLED = 'star-half-filled', 
    STAR = 'star', 
    STOPWATCH_FILLED = 'stopwatch-filled', 
    STOPWATCH = 'stopwatch', 
    SUN = 'sun', 
    SUSHI_SMALL = 'sushi-small', 
    SUSHI = 'sushi', 
    SWISS_FRANC_SMALL = 'swiss-franc-small', 
    SWISS_FRANC = 'swiss-franc', 
    SYNC = 'sync', 
    TACO_SMALL = 'taco-small', 
    TACO = 'taco', 
    TAKEAWAY_PAY_FILLED = 'takeaway-pay-filled', 
    TAKEAWAY_PAY = 'takeaway-pay', 
    TARGET_SMALL = 'target-small', 
    TARGET = 'target', 
    TEMP_SMALL = 'temp-small', 
    TEMP = 'temp', 
    TERMS_AND_CONDITIONS = 'terms-and-conditions', 
    TOILET_SMALL = 'toilet-small', 
    TOILET = 'toilet', 
    TRANSLATE = 'translate', 
    TRASH_FILLED_SMALL = 'trash-filled-small', 
    TRASH_FILLED = 'trash-filled', 
    TRASH_SMALL = 'trash-small', 
    TRASH = 'trash', 
    TUTORIAL = 'tutorial', 
    TWITTER_CIRCLE_FILLED = 'twitter-circle-filled', 
    TWITTER_CIRCLE = 'twitter-circle', 
    UNLINK = 'unlink', 
    UPLOAD = 'upload', 
    USER_ADD = 'user-add', 
    USER_CIRCLE_FILLED = 'user-circle-filled', 
    USER_CIRCLE = 'user-circle',
    USER_CANCELLED = 'user-cancelled',
    USER_COMMUNITY = 'user-community', 
    USER_FILLED = 'user-filled', 
    USER_GROUP_SMALL = 'user-group-small', 
    USER_GROUP = 'user-group', 
    USER_HIGHLIGHT_SMALL = 'user-highlight-small', 
    USER_HIGHLIGHT = 'user-highlight', 
    USER_MARKER = 'user-marker', 
    USER_PARTNERSHIP = 'user-partnership', 
    USER_REPEAT = 'user-repeat', 
    USER_SHIELD = 'user-shield', 
    USER = 'user', 
    USERS = 'users', 
    VEGAN = 'vegan', 
    VEGETARIAN_FILLED_SMALL = 'vegetarian-filled-small', 
    VEGETARIAN_FILLED = 'vegetarian-filled', 
    VEGETARIAN_SMALL = 'vegetarian-small', 
    VEGETARIAN = 'vegetarian', 
    VISION_SMALL = 'vision-small', 
    VISION = 'vision', 
    VOUCHER_FILLED = 'voucher-filled', 
    VOUCHER_SMALL = 'voucher-small', 
    VOUCHER = 'voucher', 
    WALKING = 'walking', 
    WALLET_FILLED_SMALL = 'wallet-filled-small', 
    WALLET_FILLED = 'wallet-filled', 
    WALLET = 'wallet', 
    WIFI_ALERT_SMALL = 'wifi-alert-small', 
    WIFI_ALERT = 'wifi-alert', 
    WIFI_SMALL = 'wifi-small', 
    WIFI = 'wifi', 
    WORLD = 'world', 
    WRAP_SMALL = 'wrap-small', 
    WRAP = 'wrap', 
    YOUTUBE_CIRCLE = 'youtube-circle',
    IC_TIPS = 'ic-tips',
    IC_DISTANCE = 'ic-distance'
}


export default React.forwardRef(JetFontIcon)